import React from 'react';
import {
  MappingRow,
  type MappingValue,
} from '../create-trigger-modal/mapping-row';

type LiteralType = 'string' | 'number' | 'boolean' | 'json' | 'null';

interface InputMappingSectionProps {
  fieldKeys: string[];
  requiredFields: Set<string>;
  mapping: Record<string, MappingValue>;
  eventPathOptions: string[];
  fieldExpectedLiteralTypes: Record<string, LiteralType>;
  onChange: (fieldKey: string, value: MappingValue) => void;
  emptyMessage?: string;
  className?: string;
}

export const InputMappingSection: React.FC<InputMappingSectionProps> = ({
  fieldKeys,
  requiredFields,
  mapping,
  eventPathOptions,
  fieldExpectedLiteralTypes,
  onChange,
  emptyMessage = 'No hay entradas para mapear.',
  className,
}) => {
  return (
    <div className={`space-y-2 min-w-[520px] ${className ?? ''}`}>
      {fieldKeys.length === 0 ? (
        <p className="text-sm text-gray-600">{emptyMessage}</p>
      ) : (
        fieldKeys.map((key) => (
          <MappingRow
            key={key}
            fieldKey={key}
            required={requiredFields.has(key)}
            value={mapping[key]}
            eventPathOptions={eventPathOptions}
            expectedLiteralType={fieldExpectedLiteralTypes[key]}
            onChange={(v: MappingValue) => onChange(key, v)}
          />
        ))
      )}
    </div>
  );
};
